import { render, staticRenderFns } from "./FormTableItems.vue?vue&type=template&id=734e6ddd"
import script from "./FormTableItems.vue?vue&type=script&lang=js"
export * from "./FormTableItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports